import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { redpacketLedgerEntriesDataProvider } from './dataProvider';

export function initSocialTradingRedpacketLedgerEntriesDataProvider() {
  registerModuleDataProvider(
    Resources.socialTradingRedpacketLedgerEntries,
    redpacketLedgerEntriesDataProvider
  );
}

initSocialTradingRedpacketLedgerEntriesDataProvider();
